module.exports = __webpack_public_path__ + "static/media/zappy_logo.9cd5ffa8.svg";